import { motion } from "framer-motion";
import SponsorCard from "./SponsorCard";
import { SPONSORS } from "@/utils/constants";
import Button from "../common/Button";

const SponsorBlock = () => {
  return (
    <section className="py-16 bg-gray-100 dark:bg-gray-900 transition-colors duration-300">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-gray-800 dark:text-white mb-4">
            Our Sponsors
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            Proudly supported by these amazing partners who believe in cycling
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {SPONSORS.map((sponsor, index) => (
            <SponsorCard key={sponsor.id} sponsor={sponsor} index={index} />
          ))}
        </div>

        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-center mt-12"
        >
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Interested in becoming a sponsor?
          </p>
          <div className="inline-block">
            <Button size="lg" className="shadow-md hover:shadow-lg">
              Contact Us
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SponsorBlock;
